module.exports = __webpack_public_path__ + "img/r-stack.930ece49.png";